import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { BotService } from 'src/app/core/services/bot.service';
import { ChatbotliveService } from 'src/app/core/services/chatbot_live.service';

@Component({
  selector: 'globot-preferences-box',
  templateUrl: './preferences-box.component.html',
  styleUrls: ['./preferences-box.component.scss'],
})
export class PreferencesBoxComponent implements OnInit, OnDestroy {
  @Input() botId: string = '';
  @Output() preferencesSaved = new EventEmitter<number>();
  @Output() preferenceCancelled = new EventEmitter<void>();

  selectedTime: number = 0;
  timeOptions = [5, 15, 120];
  private subscription!: Subscription;

  constructor(
    private chatbotliveService: ChatbotliveService,
    private messageService: MessageService,
    private botService: BotService
  ) {}

  ngOnInit() {
    if (this.botId) {
      this.subscription = this.botService.getBot$(this.botId).subscribe({
        next: (botData) => {
          this.selectedTime = botData?.ai_response_delay || 0;
        },
        error: (error) => {
          console.error('Error al cargar datos del bot', error);
        },
      });
    }
  }

  formatTimeOption(minutes: number): string {
    switch (minutes) {
      case 5:
        return '5 minutos';
      case 15:
        return '15 minutos';
      case 120:
        return '2 horas';
      default:
        return `${minutes} minutos`;
    }
  }

  savePreferences() {
    if (this.selectedTime && this.botId) {
      this.chatbotliveService.setAiResponseDelay(this.botId, this.selectedTime).subscribe({
        next: (_response) => {
          // Notificación de éxito
          this.messageService.add({
            severity: 'success',
            summary: 'Preferencias Guardadas',
            detail: `Tiempo de respuesta establecido a ${this.formatTimeOption(this.selectedTime)}`,
          });

          // Emitir el tiempo seleccionado
          this.preferencesSaved.emit(this.selectedTime);
        },
        error: (error) => {
          // Notificación de error
          this.messageService.add({
            severity: 'error',
            summary: 'Error al guardar preferencias',
            detail: 'Por favor, inténtalo más tarde',
          });

          console.error('Error al guardar preferencias', error);
        },
      });
    }
  }

  cancelPreferences() {
    this.preferenceCancelled.emit();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
